import { render } from "./designated-site-agent.vue?vue&type=template&id=94d6125a&scoped=true"
import script from "./designated-site-agent.vue?vue&type=script&lang=js"
export * from "./designated-site-agent.vue?vue&type=script&lang=js"

import "./designated-site-agent.vue?vue&type=style&index=0&id=94d6125a&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d6125a"]])

export default __exports__